import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import axios from "../../../../../../Global/axios";
import { AiFillCloseCircle } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../../store/userSlice";
import { setArrayValues } from "./candidateListFunctions";

export default function AddNewCandidate({
  showPromptElement,
  setShowPromptElement,
  candidateListData,
  projectId,
  setCandidateListData,
}) {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [sector, setSector] = useState("");
  const [nationality, setNationality] = useState("");
  const [religion, setReligion] = useState("");
  const [date, setDate] = useState("");
  const [remark, setRemark] = useState("");
  const [actualPosition, setActualPosition] = useState("");
  const [dob, setDob] = useState("");
  const [age, setAge] = useState("");
  const [grade, setGrade] = useState("");
  const [basic, setBasic] = useState("");
  const [food, setFood] = useState("");
  const [fixedOt, setFixedOt] = useState("");
  const [hra, setHra] = useState("");
  const [travelAllowance, setTravelAllowance] = useState("");
  const [mobileAllowance, setMobileAllowance] = useState("");
  const [airTicketAllowance, setAirTicketAllowance] = useState("");
  const [additonalOt, setAdditonalOt] = useState("");
  const [OtherAllowance, setOtherAllowance] = useState("");
  const [dutyHours, setDutyHours] = useState("");
  const [fixedOtHours, setFixedOtHours] = useState("");
  const [contractDuration, setContractDuration] = useState("");
  const [ProbationPeriod, setProbationPeriod] = useState("");
  const [passportIssueDate, setPassportIssueDate] = useState("");
  const [passportExpiryDate, setPassportExpiryDate] = useState("");
  const [emergencyContactPerson, setEmergencyContactPerson] = useState("");
  const [emergencyContactNumber, setEmergencyContactNumber] = useState("");
  const [covidVaccine, setCovidVaccine] = useState("");
  const [bloodGroup, setBloodGroup] = useState("");
  const [passportNumber, setPassportNumber] = useState("");
  const [name, setName] = useState("");

  const reverseDate = (date) => {
    if (date) {
      return date.toString().split("-").reverse().join("-");
    } else {
      return "";
    }
  };

  const HandleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const FormData = {
      project_id: projectId,
      name: name?.toUpperCase(),
      job_position_id: actualPosition,
      sector_id: sector,
      nationality_id: nationality,
      religion: religion,
      passport_number: passportNumber?.toUpperCase(),
      passport_issue_date: reverseDate(passportIssueDate),
      passport_expiry_date: reverseDate(passportExpiryDate),
      dob: reverseDate(dob),
      age: age,
      selection_date: reverseDate(date),
      blood_group: bloodGroup,
      approval_remark: remark?.toUpperCase(),
      selection_grade: grade?.toUpperCase(),
      basic: basic,
      food: food,
      fixed_ot: fixedOt,
      hra: hra,
      travel_allowance: travelAllowance,
      mobile_allowance: mobileAllowance,
      air_ticket_allowance: airTicketAllowance,
      additional_ot: additonalOt,
      other_allowance: OtherAllowance,
      duty_hours: dutyHours,
      fixed_ot_hours: fixedOtHours,
      duration_of_contract: contractDuration,
      probation_period: ProbationPeriod,
      emergency_contact_person_in_home_country:
        emergencyContactPerson?.toUpperCase(),
      emergency_contact_number_in_home_country: emergencyContactNumber,
      covid_vaccine: covidVaccine,
    };
    try {
      const res = await axios.post(`/dashboard/project-candidates`, FormData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status == 200) {
        setLoading(false);
        setArrayValues(res?.data?.data, setCandidateListData);
        dispatch(setAppError({ msg: res.data.message, color: "success" }));
        setShowPromptElement(false);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      if (error?.response?.data?.message) {
        dispatch(setAppError({ msg: error?.response?.data?.message }));
      } else {
        dispatch(setAppError({ msg: error?.message }));
      }
    }
  };

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen  bg-black/50 justify-center items-center ${
        showPromptElement ? "flex" : "hidden"
      }`}
    >
      <div className="w-full relative max-w-md   h-[500px] overflow-y-auto uppercase min-h-[14rem] rounded-md bg-white/90">
        <form
          onSubmit={HandleFormSubmit}
          className="flex flex-col gap-3 px-2 py-3"
        >
          <div className="flex justify-between  items-center">
            <h2 className="block text-lg text-left font-bold text-gray-700 ">
              Add New Candidate
            </h2>
            <AiFillCloseCircle
              className="cursor-pointer"
              size={"1.4rem"}
              onClick={() => {
                setShowPromptElement(false);
              }}
            />
          </div>
          <div className=" p-4  text-center flex justify-center flex-col">
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                SELECTION SECTOR
              </label>
              <select
                defaultValue={""}
                className="select select-bordered select-sm w-full"
                onChange={(e) => setSector(e.target.value)}
                required
              >
                <option value={""} hidden></option>
                {candidateListData?.sector?.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                NATIONALITY
              </label>
              <select
                className="select select-bordered select-sm w-full"
                onChange={(e) => setNationality(e.target.value)}
                required
              >
                <option value={""} hidden></option>
                {candidateListData?.nationality?.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">RELIGION</label>
              <select
                defaultValue={""}
                className="select select-bordered select-sm w-full"
                onChange={(e) => setReligion(e.target.value)}
              >
                <option value={""} hidden></option>
                <option value={"MUSLIM"}>MUSLIM</option>
                <option value={"NON MUSLIM"}>NON MUSLIM</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                DATE OF SELECTION
              </label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="date"
                required
                onChange={(e) => {
                  setDate(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                APPROVAL REMARK
              </label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="text"
                onChange={(e) => {
                  setRemark(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                EMPLOYEE NAME
              </label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="text"
                name="employee_name"
                placeholder="Employee name"
                onChange={(e) => {
                  setName(e.target.value);
                }}
                required
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                PASSPORT NO
              </label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="text"
                required
                onChange={(e) => {
                  setPassportNumber(e.target.value);
                }}
              />
            </div>

            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                ACTUAL PROFESSION
              </label>
              <select
                defaultValue={""}
                className="select select-bordered select-sm w-full"
                onChange={(e) => setActualPosition(e.target.value)}
                required
              >
                <option value={""} hidden></option>
                {candidateListData?.job_possition?.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                DATE OF BIRTH
              </label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="date"
                onChange={(e) => {
                  setDob(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">AGE </label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setAge(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                SELECTION GRADE
              </label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="text"
                onChange={(e) => {
                  setGrade(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">BASIC SALARY</label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setBasic(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">FOOD ALLOWANCE</label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setFood(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left  uppercase mb-1">
                Fixed OT
              </label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setFixedOt(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left  uppercase mb-1">HRA</label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setHra(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left  uppercase mb-1">
                Travel Allowance
              </label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setTravelAllowance(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left  uppercase mb-1">
                Mobile Allowance
              </label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setMobileAllowance(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left  uppercase mb-1">
                Air Ticket Allowance
              </label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setAirTicketAllowance(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left  uppercase mb-1">
                Additional OT
              </label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setAdditonalOt(e.target.value);
                }}
              />
            </div>

            <div className="mb-3">
              <label className="block text-left  uppercase mb-1">
                Other Allowance
              </label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setOtherAllowance(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left  uppercase mb-1">
                DUTY HOURS
              </label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setDutyHours(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left  uppercase mb-1">
                FIXED OT HOURS
              </label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setFixedOtHours(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                DURATION OF CONTRACT
              </label>
              <select
                className="select select-bordered select-sm w-full"
                defaultValue={"12 MONTHS"}
                onChange={(e) => setContractDuration(e.target.value)}
              >
                <option value={""} hidden></option>
                <option value={"6 MONTHS"}>6 MONTHS</option>
                <option value={"12 MONTHS"}>12 MONTHS</option>
                <option value={"24 MONTHS"}>24 MONTHS</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                PROBATION PERIOD
              </label>
              <select
                className="select select-bordered select-sm w-full"
                defaultValue={"3 MONTHS"}
                onChange={(e) => setProbationPeriod(e.target.value)}
              >
                <option value={""} hidden></option>
                <option value={"3 MONTHS"}>3 MONTHS</option>
                <option value={"6 MONTHS"}>6 MONTHS</option>
                <option value={"9 MONTHS"}>9 MONTHS</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                PASSPORT ISSUE DATE
              </label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="date"
                onChange={(e) => {
                  setPassportIssueDate(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                PASSPORT EXPIRY DATE
              </label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="date"
                onChange={(e) => {
                  setPassportExpiryDate(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                EMERGENCY CONTACT PERSON IN HOME COUNTRY
              </label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="text"
                onChange={(e) => {
                  setEmergencyContactPerson(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                EMERGENCY CONTACT NUMBER IN HOME COUNTRY
              </label>
              <input
                className="uppercase input-sm w-full input input-bordered"
                type="number"
                onChange={(e) => {
                  setEmergencyContactNumber(e.target.value);
                }}
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                COVID VACCINE
              </label>
              <select
                className="select select-bordered select-sm w-full"
                onChange={(e) => setCovidVaccine(e.target.value)}
              >
                <option value={""} hidden></option>
                <option value={"DOSE 1"}>DOSE 1</option>
                <option value={"DOSE 2"}>DOSE 2</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                BLOOD GROUP
              </label>
              <select
                className="select select-bordered select-sm w-full"
                onChange={(e) => setBloodGroup(e.target.value)}
              >
                <option value={""} hidden></option>
                <option value={"A+"}>A+</option>
                <option value={"B+"}>B+</option>
                <option value={"AB+"}>AB+</option>
                <option value={"AB-"}>AB-</option>
                <option value={"O+"}>O+</option>
                <option value={"O-"}>O-</option>
                <option value={"A-"}>A-</option>
                <option value={"B-"}>B-</option>
              </select>
            </div>
          </div>

          <div className="flex gap-3  m-5 justify-center items-center">
            <button
              className="p-1 w-full uppercase rounded-md ring-1 ring-slate-600"
              disabled={loading}
              onClick={() => {
                setShowPromptElement(false);
              }}
            >
              Cancel
            </button>
            <button
              className="p-1 w-full uppercase rounded-md ring-1 ring-red disabled:bg-rose-400 text-white bg-red"
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <CgSpinner className="animate-spin mx-auto" />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
